export default __webpack_public_path__ + "./images/fk.ad18aba4.png";